import {KRBS_CIRCULARS_APP, KRBS_CIRCULARS, CHANGE_USER_PASSWORD} from '@/config/constants.config';
import axios from 'axios';
import {AlertService} from '@/service/alert.service';
import {AppService} from '@/service/app.service';
import {toLower} from 'lodash';

const initAuthUser = () => {
  return {
    authUser: {},
    // authUsers: [],
    // authPos: {},
    formAuthData: {
      username: null,
      password: null,
      is_staff: false,
    },

    expiredAt: null,
    currentDate: null,
  };
};

const state = {
  ...initAuthUser(),
};

const mutations = {
  set_auth_user(state, payload) {
    state.authUser = payload;
  },
  set_auth_user_scope(state, payload) {
    state.authUser.scope = payload;
  },
  set_pos(state, payload) {
    state.authPos = payload; // sysad or staff
  },

  set_token(state, payload) {
    localStorage.setItem(KRBS_CIRCULARS_APP.TOKEN, payload);
  },

  set_token_expired_at(state, payload) {
    state.expiredAt = payload;
  },

  set_token_current_date(state, payload) {
    state.currentDate = payload;
  },

  log_out(state) {
    Object.assign(state, initAuthUser());
  },

  reset_form_auth_data(state) {
    state.formAuthData = {
      username: null,
      password: null,
    };
  },

  set_logout_auth(state) {
    localStorage.clear();
    state.authUser = {};
    // state.authPos = {};
    // state.authUserSystems = [];
  },

};

const actions = {
  async loginUser({commit}, payload) {
    commit('set_is_loading', true);
    return await axios.post(KRBS_CIRCULARS.LOGIN, payload).then((r) => {
      // console.log(r.data.expiredAt, 'login creds');
      // console.log(r.data.currentDate, 'Current Date');
      localStorage.setItem('loggedInUser', JSON.stringify(state.formAuthData));
      commit('set_token_expired_at', r.data.expiredAt);
      commit('set_token_current_date', r.data.currentDate);

      commit('set_auth_user', r.data.user);
      commit('set_auth_user_scope', r.data.scope);
      commit('set_token', r.data.token);
      commit('set_is_loading', false);
      commit('reset_form_auth_data');

      return true;

    }).catch((e) => {
      // AlertService.errorAlertService("Wrong Username / Password",'Login Error')
      // console.log(e.response.data.errors, 'whta the helllll')
      commit('set_is_loading', false);

      AlertService.responseAlertMessage(e, 'Login');
      // AlertService.responseAlertMessage(e, 'Log in Error');
      return false;
    });
  },

  async logoutUser({commit, rootState}) {
    let userType = toLower(rootState.AuthModule.authUser.scope);
    return await axios.post(`${userType}` + KRBS_CIRCULARS.LOGOUT, {}).then((r) => {
      commit('set_logout_auth');
      return true;
    }).catch((e) => {
      return false;
    });
  },

  async changeUserPassword({ commit }, params) {
    let updatedUserPassword = await AppService.submitPostData(CHANGE_USER_PASSWORD, params);
    if(updatedUserPassword) {
      if(updatedUserPassword.errors) {
        return updatedUserPassword
      } else {
        return true;
      }
    }
    return false;
  }

};

const getters = {
  formAuthData: state => state.formAuthData,
  authUser: state => AppService.capitalizeProperties(state.authUser),
  authUsers: state => state.authUsers,
  authPos: state => state.authPos,

  expiredAt: state => state.expiredAt,
  currentDate: state => state.currentDate,
};

/** export **/
export default {state, actions, mutations, getters};
